import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const accordionStyle = {
  backgroundColor: '#0f111a',
  color: '#c6a04c',
  border: '1px solid #c6a04c',
  borderRadius: 1,
  mb: 2
};

const InfoPage = () => {
  const { t } = useTranslation();

  const section1Points = t('infopage.section1.points', { returnObjects: true }) as string[];
  const section2Points = t('infopage.section2.points', { returnObjects: true }) as string[];
  const section3Steps = t('infopage.section3.steps', { returnObjects: true }) as string[];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ px: 3, py: 5, maxWidth: '800px', mx: 'auto' }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#c6a04c' }}>
          {t('infopage.title')}
        </Typography>

        <Typography variant="body1" paragraph sx={{ color: '#c6a04c' }}>
          {t('infopage.intro')}
        </Typography>

        {/* Sektion 1 */}
        <Accordion sx={accordionStyle}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#c6a04c' }} />}>
            <Typography fontWeight="bold">{t('infopage.section1.title')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography paragraph>{t('infopage.section1.text')}</Typography>
            <List dense>
              {section1Points.map((point, index) => (
                <ListItem key={index}><ListItemText primary={point} /></ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Sektion 2 */}
        <Accordion sx={accordionStyle}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#c6a04c' }} />}>
            <Typography fontWeight="bold">{t('infopage.section2.title')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense>
              {section2Points.map((point, index) => (
                <ListItem key={index}><ListItemText primary={point} /></ListItem>
              ))}
            </List>
            <Typography variant="body2" mt={1}>
              {t('infopage.section2.text')}
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* Sektion 3 */}
        <Accordion sx={accordionStyle}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#c6a04c' }} />}>
            <Typography fontWeight="bold">{t('infopage.section3.title')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense>
              {section3Steps.map((step, index) => (
                <ListItem key={index}><ListItemText primary={step} /></ListItem>
              ))}
            </List>
            <Typography variant="body2" mt={1}>
              {t('infopage.section3.text')}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </motion.div>
  );
};

export default InfoPage;
